/**
 * /advertisers/campaign-upload — self-service campaign submission landing.
 *
 * Declares the TanStack Router route and delegates rendering to
 * `AdvertiserCampaignUploadPage`. Flat-file naming: dots map to path
 * separators, so `advertisers.campaign-upload.tsx` mounts at
 * `/advertisers/campaign-upload`.
 *
 * Mirrors `advertisers.portal.tsx` so the wire-up cycle can mount it the
 * same way.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { AdvertiserCampaignUploadPage } from "@/features/advertiser-campaign-upload/AdvertiserCampaignUploadPage";

// ---------------------------------------------------------------------------
// Route — mounts at `/advertisers/campaign-upload`. `advertiserId` search
// param is reserved for future drilldown deep links; not consumed yet.
// ---------------------------------------------------------------------------

interface AdvertiserCampaignUploadSearch {
	advertiserId?: string;
}

export const advertisersCampaignUploadRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertisers/campaign-upload",
	validateSearch: (
		raw: Record<string, unknown>,
	): AdvertiserCampaignUploadSearch => {
		const advertiserId = raw.advertiserId;
		if (typeof advertiserId === "string" && advertiserId.trim().length > 0) {
			return { advertiserId: advertiserId.trim() };
		}
		return {};
	},
	component: AdvertiserCampaignUploadPage,
});

export default advertisersCampaignUploadRoute;

export { AdvertiserCampaignUploadPage } from "@/features/advertiser-campaign-upload/AdvertiserCampaignUploadPage";
